<style scpoed >

.top-margin {
    margin-left: 5px
}

</style>

<template>

<div class="">

    <div class="">

        <list-template ref="list-template"  :hasSearch="false" actionUrl="carShow/carShowInfo/getAdvertisementInfo.action" :queryParams="searchInfo">

            <template slot="item" scope="scope">
                <div>
                    <el-card class="basic-margin" :key="index"  v-for="(data,index) in scope.datas">
                        <el-row>
                            <el-col :span="3" style="text-align:left;margin-left:20px;">
                                <img :src="baseImageUrl+data.image" style="width:120px;height:120px;margin-left:10pt;" alt="">
                            </el-col>
                            <el-col :span="8" style="text-align:left;margin-left:20px;">
                                <div style="font-size:1.8rem;">网上车展广告位-{{index+1}}</div>
                                <div v-html="data.link" style="color:#999;font-size:1.4rem;margin-top:20pt;word-wrap: break-word;word-break: break-all;overflow: hidden;">
                                </div>
                            </el-col>

                            <el-col :span="6" style="text-align:left;margin-left:20px;margin-top:20pt;">
                                <el-button type="primary" @click="showDig(data)">更换</el-button>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </template>
        </list-template>

        <el-dialog size="tiny" title="更换 广告" :visible.sync="dialogVisible" width="40%" >
          <el-row>
              <el-form :model="advertForm"  :rules="rules" ref="advertForm"  label-width="150px">

                  <el-col :span="20" class="basic-margin">

                      <el-form-item label="输入广告链接:" label-position="left" prop="link">
                          <el-input v-model="advertForm.link" placeholder="请输入有效url链接">
                          </el-input>
                      </el-form-item>

                      <el-form-item label="上传封面图:" label-position="top" prop="image">
                        <el-upload accept="image/*" class="avatar-uploader" v-model="advertForm.images" :action="baseUrl+'upload/uploadPic'" :show-file-list="false" :data="{floder:'advert'}" :on-success="handleSuccess" >
                            <img v-if="advertForm.image" :src="baseImageUrl+advertForm.image" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                          <p>支持jpg格式，750*200px，用于车展主页广告位banner展示！</p>

                      </el-form-item>

                      <el-form-item class="basic-margin">
                          <el-button type="primary"  @click="submitForm('advertForm')">保存</el-button>
                          <el-button @click="back('advertForm')">取消</el-button>
                      </el-form-item>
                  </el-col>
              </el-form>
          </el-row>
        </el-dialog>
    </div>

</div>

</template>

<script>

import Config from '@/framework/configs/Config'
import AdvertModel from '@/framework/models/advertModel'
import BasicPager from '@/mixins/BasicPager'
import ListTemplate from '@/components/ListTemplate'
export default {
  name: 'advertisement-manager',
  extends: BasicPager,
  data: function () {
    return {
      baseImageUrl: Config.imageUrl,
      baseUrl: Config.baseUrl,
      searchInfo: {
        carShowInfoId: null,
        type: 1
      },
      dialogVisible: false,
      advertForm: {
        id: 0,
        link: null,
        image: null
      },
      rules: {
        link: [{
          required: true,
          message: '广告链接不能为空',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          message: '请上传封面图片',
          trigger: 'change'
        }]

      }
    }
  },

  components: {
    ListTemplate
  },
  created: function () {
    let carShowInfoId = this.$route.params.carShowInfoId
    this.searchInfo.carShowInfoId = carShowInfoId
  },
  activated: function () {
    let carShowInfoId = this.$route.params.carShowInfoId
    this.searchInfo.carShowInfoId = carShowInfoId
    this.$refs['list-template'].search()
  },
  methods: {
    showDig: function (data) {
      this.dialogVisible = true
      this.advertForm.id = data.id
      this.advertForm.link = data.link
      this.advertForm.image = data.image
    },
    edit: function () {
      let _this = this
      let params = {
        id: _this.advertForm.id,
        link: _this.advertForm.link
      }

      if (_this.advertForm.image) {
        params.image = _this.advertForm.image[0]
      }

      let listener = {
        success: function (dataInfo) {
          _this.dialogVisible = false
          _this.$message({
            type: 'success',
            message: dataInfo.errMsg
          })

          _this.$refs['list-template'].search()
        }
      }
      AdvertModel.editAdvert(this, params, listener)
    },
    handleSuccess: function (response, file, fileList) {
      this.advertForm.image = response.datas
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.edit()
        }
      })
    },
    back: function (formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    }
  }
}

</script>
